import { createClient as createSupabaseClient } from '@supabase/supabase-js';

let clientInstance: ReturnType<typeof createSupabaseClient> | null = null;

export function createClient() {
  if (clientInstance) return clientInstance;
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;
  clientInstance = createSupabaseClient(supabaseUrl, supabaseAnonKey);
  return clientInstance;
}
